module.exports = __webpack_public_path__ + "02_short_gold.fa910620.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_short_gold.png
// module id = OJ60
// module chunks = 0